import services from './services'

const external = {
    services: Object.assign(services, services),
}

export default external